import React, { useState } from 'react'
import { CurrencyIcon } from 'components/Core'
import { Card } from 'components/Core/Card/Card'
import { Input } from 'components/Core/Input/Input'
import { useCurrencies } from 'hooks/useCurrencies'
import { usePrice } from 'hooks/usePrice'
import { formatCurrency } from 'utils/format'
import '../../styles/utils.css'
import './calculators.css'

export const TradeCalculator = ({
    amount,
    toProduct,
    fromProduct,
    toProductType,
}: {
    amount: number,
    toProduct: string,
    fromProduct: string,
    toProductType: string;
}) => {
    // #region HOOKS
    const currencies = useCurrencies();
    const price = usePrice(toProduct, fromProduct, toProductType)
    // #endregion

    // #region STORE
    // #endregion

    // #region STATE
    const [valueToProduct, setValueToProduct] = useState(amount || 0)
    const [valueFromProduct, setValueFromProduct] = useState(amount || 0)
    // #endregion

    // #region HANDLERS
    const handleChangeFromProduct = (e: any) => {
        const value = e.target.value;
        console.log('fromProduct', {
            value: Number(value)?.toFixed?.(2),
            price,
            result: Number(valueFromProduct) / price,
            formatted: formatCurrency(Number(valueFromProduct) / price, toProduct)
        });

        setValueFromProduct(Number(Number(value).toFixed(2)))
        setValueToProduct(Number(Number(value / price).toFixed(8)))
    }

    const handleChangeToProduct = (e: any) => {
        const value = e.target.value;
        console.log('toProduct', {
            value: Number(value)?.toFixed?.(8),
            price,
            result: Number(valueToProduct) / price,
            formatted: formatCurrency(Number(valueToProduct) / price, toProduct)
        });

        setValueToProduct(Number(Number(value).toFixed(8)))
        setValueFromProduct(Number(Number(value * price).toFixed(2)))
    }
    // #endregion

    // #region LIFECYCLE
    // #endregion

    return (
        <div className="trade-input-container">
            <div className="trade-input-label">
                Pay
            </div>
            <br />
            <Card className="trade-input">
                <div className="flex-row justify-between">
                    <div className="flex-row">
                        <span style={{ height: '2rem', lineHeight: '3rem', fontWeight: 'bold', fontSize: '1.2rem', fontFamily: 'Bozon' }}>{currencies?.[fromProduct]?.symbol}</span>
                        <Input
                            onChange={handleChangeFromProduct}
                            type={'number'}
                            value={
                                valueFromProduct === 0
                                    ? ''
                                    : valueFromProduct
                            }
                            style={{
                                marginLeft: 0,
                                marginRight: 0,
                            }}
                        />
                    </div>
                    <div className='trade-input-code-wrapper'>
                        <CurrencyIcon code={fromProduct} size="md" style={{ marginTop: '0.5rem' }} />
                        <div className="trade-input-code">{fromProduct?.toUpperCase()}</div>
                    </div>
                </div>
            </Card>

            <br />
            <br />

            <div className="trade-input-label">
                Receive
            </div>
            <br />
            <Card className="trade-input">
                <div className="flex-row justify-between">
                    <Input
                        onChange={handleChangeToProduct}
                        type={'number'}
                        value={valueToProduct === 0
                            ? ''
                            : valueToProduct
                        }
                        style={{
                            marginLeft: 0,
                            marginRight: 0,
                        }}
                    />
                    <div className='trade-input-code-wrapper'>
                        <CurrencyIcon code={toProduct} size="md" style={{ marginTop: '0.5rem' }} />
                        <div className="trade-input-code">{toProduct?.toUpperCase()}</div>
                    </div>
                </div>
            </Card>
            <div className="trade-input-price">
                <span>
                    <span style={{ fontWeight: '600' }}>{toProduct}</span> price ={' '}
                    <span style={{ fontWeight: '600', color: currencies?.[toProduct]?.colors.primary }}>{formatCurrency(price, fromProduct)}</span>
                </span>
            </div>
            <br />
            <br />
        </div>
    )
}